<template>
  <div class="about">
  <div style="margin-left: 0px; margin-right: 0px; " class="divider row">
    
    <div  class="sidebar col-12 col-md-3">
      <!-- an account dropdown switcher in bootstrap that lets the user switch between channels-->
      <div v-if="!$store.state.inApp" class="sidebar-dropdown">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          <div class="avatar ">
            <div class="avatar-circle" width="40">
              <!-- Place initals inside avatar -->
            
              <div v-bind:style="(channel && channel.pageData) ? 'background-color: #'+channel.pageData.navcolor: ''+';'" class="initials">{{channel_initals}}</div>
            </div>
          </div>
          <span class="username">{{channel.name}}</span>
       
        </a>
        <ul v-if="!$store.state.inApp" class="dropdown-menu">
          <span>{{ $t('switch-to') }}</span>
          <br /> <br />
         <div v-if="viewerChannelAccess">
        
          <li v-for="channel in viewerChannelAccess" style=" cursor: pointer;" @click="switchToChannel(channel)" v-bind:key="channel.id"><span > {{ channel.name}}</span>
            <!-- badge for type-->
            <br />
            <span style="font-size: smaller; color: #000; cursor: pointer;">@{{ channel.id }}
              <span v-if="channel.type == 'primary'" style="margin-left: 5px;" class="badge badge-pill badge-primary">{{ $t('Primary') }}</span></span>
              <!-- badge for secondary -->
              <span v-if="channel.type == 'secondary'" style="margin-left: 5px;" class="badge badge-pill badge-secondary">{{ $t('Secondary') }}</span>
              <!-- badge for red access -->
              <span v-if="channel.type == 'access'" style="margin-left: 5px;" class="badge badge-pill badge-danger">{{ $t('Access') }}</span>
            <hr /></li>
         </div>
     
          <li v-if="!viewerChannelAccess" @click="switchToChannel(null)" ><a href="#" > {{ $t('your-channel') }}</a><hr /></li>

         <router-link style="color:grey" to="/viewer/dashboard">{{ $t('viewer-dashboard') }}</router-link><hr />
         <!-- Create new Channel -->
         <div v-if="primaryChannel" >
          <router-link style="color:grey" to="/createSecondary">Create New Channel</router-link><hr />
          </div>
          <li @click="logout()"  style="color:grey; cursor:pointer;">{{ $t('logout') }}</li>
        </ul>
      </div>
      <hr v-if="!$store.state.inApp" style="background-color:grey" />


      <router-link v-if="$store.state.inApp" to="/broadcaster/recordings" v-bind:style="page == 'recordings' ? 'color:grey': ''" class="menu-option"><i class="fa fa-video" aria-hidden="true"></i>{{ $t('Recordings') }}</router-link><br v-if="$store.state.inApp" />

           <router-link to="/broadcaster/customize" v-bind:style="page == 'customize' ? 'color:grey': ''" class="menu-option"><i class="fa fa-columns" aria-hidden="true"></i>{{$t('Customize')}}</router-link><br />

        <router-link v-if="!$store.state.inApp"  to="/broadcaster/events" v-bind:style="page == 'events' ? 'color:grey': ''" class="menu-option"><i class="fa fa-calendar-week" aria-hidden="true"></i>{{ $t('events') }}</router-link><br v-if="!$store.state.inApp" />
             <router-link v-if="!$store.state.inApp" to="/broadcaster/recordings" v-bind:style="page == 'recordings' ? 'color:grey': ''" class="menu-option"><i class="fa fa-video" aria-hidden="true"></i>{{ $t('Recordings') }}</router-link><br v-if="!$store.state.inApp" />

        <router-link to="/broadcaster/revenue" v-bind:style="page == 'revenue' ? 'color:grey': ''" class="menu-option"><i class="fa fa-dollar-sign" aria-hidden="true"></i>{{ $t('revenue') }}</router-link><br />

                         <router-link  v-if="!$store.state.inApp" to="/broadcaster/analytics"  v-bind:style="page == 'analytics' ? 'color:grey': ''" class="menu-option"><i class="fa fa-binoculars" aria-hidden="true"></i>Stats & Analytics</router-link ><br v-if="!$store.state.inApp" />

                          <router-link   to="/broadcaster/referral"  v-bind:style="page == 'referral' ? 'color:grey': ''" class="menu-option"><i class="fa fa-pen" aria-hidden="true"></i>{{ $t('Referral') }}</router-link ><br />

      <router-link  v-if="!$store.state.inApp" to="/broadcaster/develop"  v-bind:style="page == 'develop' ? 'color:grey': ''" class="menu-option"><i class="fa fa-code" aria-hidden="true"></i>{{ $t('integration') }}</router-link ><br v-if="!$store.state.inApp" />
          <router-link  v-if="!$store.state.inApp" to="/broadcaster/settings"  v-bind:style="page == 'settings' ? 'color:grey': ''" class="menu-option"><i class="fa fa-cog" aria-hidden="true"></i>{{ $t('settings') }}</router-link ><br v-if="!$store.state.inApp" >

<br />
<br />

    </div>
    
 <div class="col-12 col-md-9 full">
  
   <div v-if="channel.id">
    <div  v-if="!$store.state.inApp">
    <div v-if="channel.email.includes('+')" style="background-color: yellow; width: 100%; padding: 0.4em; border-bottom-left-radius: 1em;border-bottom-right-radius: 1em;" >
      <p style="text-align: center; font-size: 12px; margin: 0px;">Important: While using Secondary Accounts with SeasonCast iOS Legacy App (v5), you need to set your 'Streaming Protocol' to RTMP in "Broadcast Settings" & 'Profile' to High in advance broadcast settings. You can change this in broadcast settings on the device.</p>
      </div>
    
    </div>
    <Customize :channel='channel' v-if="page == 'customize'"></Customize>
    <Revenue v-if="page == 'revenue' " :channel='channel'></Revenue>
    <Recordings v-if="page == 'recordings' " :channel='channel' ></Recordings>
        <Recording v-if="page == 'recording' " :channel='channel' ></Recording>
    <Events v-if="page == 'events' " :channel='channel' ></Events>
     <Event v-if="page == 'event'" :channel='channel' ></Event>
     <CreateEvent v-if="page == 'createEvent'" :channel='channel' ></CreateEvent>
     <Remote v-if="page == 'remote'" :channel='channel' ></Remote>
     <GameFilm v-if="page == 'analytics'" :channel='channel' ></GameFilm>
     <Develop v-if="page == 'develop'" :channel='channel' ></Develop>
      <Refund v-if="page == 'refund'" :channel='channel' ></Refund>
        <Settings v-if="page == 'settings'" :channel='channel' ></Settings>
      <EditEvent v-if="page == 'editEvent'" :channel='channel' ></EditEvent>
      <Referral v-if="page == 'referral'" :channel='channel' ></Referral>
     </div>
     <div v-else>
       <br />
       <h5>{{ $t('waiting-for-channel-information') }}</h5>
     </div>
  </div>
    </div>
      </div>
</template>
<script>
  import Swal from "sweetalert2"
  import axios from "axios"
  import cookie from "cookie.js"

  import Revenue from '../components/dashboard/Revenue.vue'
  import Events from '../components/dashboard/Events.vue'
    import Recordings from '../components/dashboard/Recordings.vue'
        import Recording from '../components/dashboard/Recording.vue'

  import Event from '../components/dashboard/Event.vue'
    import CreateEvent from '../components/dashboard/CreateEvent.vue'

    //info 
      import Develop from '../components/dashboard/Develop.vue'
      import Refund from "../components/dashboard/Refund.vue"
      import Remote from '../components/dashboard/RemoteScoreboard.vue'
       import GameFilm from '../components/dashboard/GameFilm.vue'
    import Customize from '../components/dashboard/Customize.vue'
     import Settings from '../components/dashboard/Settings.vue'
     import EditEvent from '../components/dashboard/EditEvent.vue'
import Referral from '../components/dashboard/Referral.vue'

  //let API = "http://localhost:8089/"
  let API = "https://app.seasoncast.com/"

// return 2 initals for a name, if there is one word then return the first 2 characters
  function getInitials(name) {
    let nameArray = name.split(" ");
    if (nameArray.length === 1) {
      return nameArray[0].substr(0, 2);
    } else {
      return nameArray[0].substr(0, 1) + nameArray[1].substr(0, 1);
    }
  }


export default {
  components: {
  Revenue,
  Events,
  Event,
  CreateEvent,
  Recordings,
  Recording,
  Remote,
  Develop,
  Refund,
  Customize,
  GameFilm,
  Settings,
  EditEvent,
    Referral
  },
  watch: {
    '$route.params.page': function() {
      this.page = this.$route.params.page 
    },
     '$route.params.option': function() {
      this.option = this.$route.params.option 
    }
},
    data: function () {
    return {
      email: null,
      key: null,
      page: this.$route.params.page || "revenue",
      option: undefined,
      channel: { },
      channelToken: undefined,
      viewerChannelAccess: [],
      channel_initals: "__",
      primaryChannel: undefined,
    }
  },
  methods: {
    switchToChannel: async function(channel){
      if (channel){
      cookie.set('broadcaster-token', channel.token, { path: '/'});
      this.channelToken = channel.token;
      this.$store.commit('setAuth', { token: channel.token })
      }else{
        this.channelToken = null
        this.$store.commit('setAuth', { email: this.email, key: this.key })

        cookie.remove("broadcaster-token", { path: '/' })
      }
      await this.getAccount()
    },
     logout: async function () {
     cookie.remove("broadcaster-email", { path: '/' })
     cookie.remove("broadcaster-key", { path: '/' })
         cookie.remove("broadcaster-email")
     cookie.remove("broadcaster-key")
     cookie.remove("broadcaster-token", { path: '/' })
     this.$store.commit('setBroadcasterChannels', [])
     this.$router.push('/broadcaster/login');
    
     
     },
    getAccount: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/broadcaster/information", this.channelToken ? {
      token: this.channelToken
    } :
    {
    email: this.email,
    key:  this.key
  }) 

  let responseData = getEventResponse.data
  console.log(responseData)

  if (responseData.success){
    console.log("vaild")

    if (!responseData.channel.pageData){
      responseData.channel.pageData = {
        navcolor: "000000"
      }
    }
  this.channel_initals = getInitials(responseData.channel.name)
   this.channel = responseData.channel


  }else{
 console.log("not vaild")
       Swal.fire({
  icon: 'error',
  title: 'Account Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
  }

    },
   
  },
   created: async function () {
    console.log("create call")

      this.email =  cookie.get("broadcaster-email")
      this.key =  cookie.get("broadcaster-key")
      this.channelToken = cookie.get("broadcaster-token")

      try {
            this.viewerChannelAccess = this.$store.state.broadcasterChannels
            console.log("channels",this.viewerChannelAccess)
            this.primaryChannel = this.viewerChannelAccess.filter(x => !(x.broadcaster.email.includes('+'))).find(x => x.type == "primary")
            console.log("primary",this.primaryChannel)

      } catch (error) {
        console.error(error)
      }
  
      if ((!this.key || !this.email) || ( this.$store.state.broadcasterChannels && this.viewerChannelAccess.length == 0)){ 
        cookie.set('broadcaster-login-redirect', this.$route.fullPath, { path: '/'});
        this.$router.push('/broadcaster/login/')
        return
      }

      if (cookie.get('broadcaster-login-redirect')){
        this.$router.push(cookie.get('broadcaster-login-redirect'))
        cookie.remove('broadcaster-login-redirect', { path: '/'});
      }

      if (this.channelToken){
                this.$store.commit('setAuth', { token: this.channelToken })
      }else{
                this.$store.commit('setAuth', { email: this.email, key: this.key })
      }

      window.Intercom("boot", {
  api_base: "https://api-iam.intercom.io",
  app_id: "qbuqg2ke",
  email: cookie.get("broadcaster-email") ?? cookie.get("viewer-email")
});
      
  await this.getAccount()

   }
}
</script>

<style lang="scss">


  
.full{
    min-height: 100vh;
}
//dropdown with flex box to make avatar and username full width
.sidebar-dropdown{
  width: 100%;
 
   
}
.dropdown-toggle {
  width: 100%;
   display: flex;
  flex-direction: row;
   line-height: 40px;
    font-size: 1.2rem;
    color: white;
}
.dropdown-toggle:hover {
  color: #969696;
}
  .dropdown-toggle::after
  {
    margin-top: 17px;
  }
// circle avatar class
.avatar-circle {
  border-radius: 50%;
  width: 40px;
  height: 40px;
flex: 1 1 0;
}
// initals class
.initials {
  font-size: 12px;
  color: #fff;
  font-weight: bold;
  text-align: center;

  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  flex: 1 1 auto;
}

.sidebar-dropdown .dropdown-menu{

  background-color: #fff;
  border-radius: 0.2rem;
  width: 100%;
  -webkit-box-shadow: 0 5px 10px rgba(0,0,0,.2);
  box-shadow: 0 5px 10px rgba(0,0,0,.2);
  color: #969696;
  text-align: center;
}
.dropdown-menu a {
  color: #4579bd;
  width: 100%;
}
.dropdown-menu li {
  color: #4579bd;
  width: 100%;
  text-align: center;
}
.username {
    font-size: 1.2rem;
    padding-left: 10px;
    line-height: 40px;
    text-align: center;
 flex-grow: 2;
   white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}
// caret should be the same height and flex to the right and 20px width and 40px height and 40px line height


  .sidebar {
    background-color: #2d2d54;

    width: 100%;
    padding: 2em;
    color: rgb(212, 212, 212);
    font-weight: 500;
  
  }
.channelHeader{
  color:rgb(240, 240, 240);
}
  .divider {

    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    .divider {
      min-height: 93%;

    }
  }



  .menu-active {
    color: blue;
  }

  .menu-option {
    cursor: pointer;
    line-height: 1.9em;
    width: 100%;
    color: white
  }

  .menu-option i {
    width: 10%;
    text-align: center;
    margin-right: 5px;
    margin-left: 5px;
  }

  .dashContain {
    padding: 2em
  }
</style>
